package com.hyperether.goodjob.scenes.dashboard

import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateOf
import androidx.lifecycle.viewModelScope
import com.hyperether.goodjob.getPlatformChecker
import com.hyperether.goodjob.models.UserStatus
import com.hyperether.goodjob.repository.Mapper
import com.hyperether.goodjob.repository.Repository
import com.hyperether.goodjob.repository.remote.model.Resource
import com.hyperether.goodjob.scenes.JobsViewModel
import com.hyperether.goodjob.scenes.scheduler.PeriodType
import com.hyperether.goodjob.util.FilterDialogStateManager
import com.hyperether.goodjob.util.ScheduleUtil
import com.hyperether.planner.model.Plan
import com.hyperether.resources.currentLanguage
import kotlinx.coroutines.delay
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.SharedFlow
import kotlinx.coroutines.flow.collectLatest
import kotlinx.coroutines.launch
import kotlinx.datetime.Clock
import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.todayIn
import org.lighthousegames.logging.logging

class DashboardViewModel(repository: Repository) : JobsViewModel(repository) {

    val log = logging("DashboardViewModel")

    private val isUserStatusActive = MutableStateFlow(true)
    private val _navigateToRegister = MutableSharedFlow<Unit>(extraBufferCapacity = 1)
    val navigateToRegister: SharedFlow<Unit> = _navigateToRegister

    val isManagerNumberExceeded: MutableState<Boolean> =
        mutableStateOf(repository.isManagerNumberExceeded())
    val isEmployeeNumberExceeded: MutableState<Boolean> =
        mutableStateOf(repository.isEmployeeNumberExceeded())
    val showAreYouSurePopUpDeleteJob: MutableState<Boolean> = mutableStateOf(false)

    private var selectedDay: LocalDate = Clock.System.todayIn(TimeZone.currentSystemDefault())
    var listOfPlans = mutableStateListOf<Plan>()

    init {
        tag = "DashboardViewModel"
        if (getPlatformChecker().isMobile())
            init()
    }

    fun init() {
        log.d("DashboardViewModel") { "init isMobile: ${getPlatformChecker().isMobile()}" }
        FilterDialogStateManager.setDialogShowing(false)
        resetFilter()
        initViewModel()
        viewModelScope.launch {
            repository.getJobsFlow().collect {
                delay(250)
                parseSchedule()
            }
        }

        viewModelScope.launch {
            repository.getUsersFlow().collect {
                delay(250)
                parseSchedule()
            }
        }

        observeUserStatus()
        loadRemoteData()
    }

    private fun observeUserStatus() {
        viewModelScope.launch {
            isUserStatusActive
                .collectLatest { active ->
                    if (!active) {
                        _navigateToRegister.emit(Unit)
                        logout()
                    }
                }
        }
    }

    override fun loadRemoteData() {
        super.loadRemoteData()
        repository.getToken().takeIf { it.isNotEmpty() }?.let {
            viewModelScope.launch {
                getAllUsers()
                repository.getAllContactsByWorkspace()
                repository.getTeams()
            }
        }
    }

    private suspend fun getAllUsers() {
        when (val result = repository.getUsers()) {
            is Resource.Success -> {
                val currentUser = repository.getUser()
                isUserStatusActive.value = currentUser?.status == UserStatus.active.name
                currentUser?.let { currentUser ->
                    if (currentUser.lang != currentLanguage.value.code) {
                        // Language change detected
                        currentUser._id?.let {
                            currentUser.lang = currentLanguage.value.code
                            repository.updateUser(it, Mapper().toUserRequest(currentUser))
                        }
                    }
                }
                repository.checkRestrictions()
            }

            is Resource.Error -> {
                println(result)
            }
        }
    }

    fun parseSchedule() {
        log.d { "Scheduler DashboardViewModel parseSchedule" }
        viewModelScope.launch {
            listOfPlans.clear()
            ScheduleUtil.getPlanList(
                jobs = filteredJobs,
                periodType = PeriodType.DAY,
                selectedDay = selectedDay,
                weekSelectionStart = Clock.System.todayIn(TimeZone.currentSystemDefault()),
                weekSelectionEnd = Clock.System.todayIn(TimeZone.currentSystemDefault()),
                monthSelectionLocalDate = Clock.System.todayIn(TimeZone.currentSystemDefault()),
                listOfPlans = listOfPlans,
                employeeId = if (isEmployee()) repository.getUser()?._id else null
            )
//            if (isEmployee())
//                ScheduleUtil.filterEmployeeJobs(repository.getUser()!!.getName(), listOfPlans)
        }
    }

    private fun logout() {
        viewModelScope.launch {
            com.hyperether.goodjob.log.d { "Dashboard logout" }
            repository.logoutUser()
        }
    }
}